// extracted by mini-css-extract-plugin
module.exports = {"blockName":"UploadDebtsFile_blockName__2L1CF","title":"UploadDebtsFile_title__2H-UG","name":"UploadDebtsFile_name__8aDxn"};